import React, { useState, useEffect, useCallback } from 'react';
import { withAppHOC } from '../../../hoc';
import PageHeading from '../../../components/PageHeader/PageHeader';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import NoData from '../../../components/NoData/NoData';
import { MessageBox, Button } from '../../../components/FormElements';
import { TableBuilder } from '../../../components/TableElements';
import Pagination from '../../../components/Pagination/Pagination';
import API from '../../../api';
import { API_RESPONSE_TYPES } from '../../../constants';
import {
  getSearchParams,
  shouldRedirect,
  redirectToPageOne,
} from '../../../utils';

const Downloads = (props) => {
  const [paginationData, setPaginationData] = useState({
    pageNumber: getSearchParams('pageNumber') || 1,
    recordsPerPage: getSearchParams('recordsPerPage') || 200,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [downloads, setDownloads] = useState([]);

  const readData = useCallback(() => {
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.get(
      `/reports/downloads?pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}`
    )
      .then((response) => {
        const { status, data, pageInfo } = response.data;
        if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
          redirectToPageOne();
        } else {
          if (status === API_RESPONSE_TYPES.SUCCESS) {
            setTotalRecords(pageInfo.totalRecords);
          }
          setDownloads(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [paginationData]);

  const reloadData = () => {
    readData();
  };

  useEffect(() => {
    readData();
  }, [paginationData, readData]);

  return (
    <>
      <PageHeading {...props} canReloadProp={true} reloadData={reloadData} />
      <LoadingSpinner
        isLoading={
          responseStatus === '' && downloads?.length === 0 && isLoading
        }
      />
      <NoData
        status={
          responseStatus !== API_RESPONSE_TYPES.FAILURE &&
          !isLoading &&
          downloads?.length === 0
        }
        message={`No downloads found`}
      />
      <MessageBox status={responseStatus} message={responseMessage} />
      {downloads?.length > 0 && (
        <>
          <TableBuilder
            isLoading={downloads?.length !== 0 && isLoading}
            tableHeadings={[
              {
                title: 'Requested On',
                dataSelector: 'createdOn',
                dataType: 'string',
              },
              {
                title: 'Data Type',
                dataSelector: 'dataType',
                dataType: 'string',
              },
              {
                title: 'From Date',
                dataSelector: 'fromDate',
                dataType: 'string',
              },
              {
                title: 'To Date',
                dataSelector: 'toDate',
                dataType: 'string',
              },
              {
                title: 'Status',
                dataSelector: 'status',
                dataType: 'string',
                align: 'center',
                CellRenderer: (value, item) =>
                  value === 'Success' ? (
                    <Button onClick={() => window.open(item.url, '_blank')}>
                      Download
                    </Button>
                  ) : (
                    value
                  ),
              },
            ]}
            tableData={downloads}
          />
          <Pagination
            totalRecords={totalRecords}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </>
      )}
    </>
  );
};

export default withAppHOC(Downloads);
